import { React, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import webServices from '../../../services/webServices';

const LikedOrBlockedUsersPopup = ({ user, popupType, modalStatus, handleClose }) => {
  const [dataList, setDataList] = useState([]);

  useEffect(() => {
    if (modalStatus) {
      webServices.getMatchedOrBlockedUsersListById(user.id, popupType)
        .then((response) => {
          if (response && response.success) {
            setDataList(response.data);
          }
        });
    }

    return () => {
      setDataList([]);
    }
  }, [modalStatus]);


  return (
    <Modal
      className="filter-model dashboard_popup like_blockpopup"
      show={modalStatus}
      onHide={handleClose}
      centered
    // backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title className="w-100">
          <h5 className="modal-title w-100">{popupType === 'blocked' ? 'Blocked' : 'Matched'} Users</h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ul className='unstyled'>
          {
          dataList.length > 0
          ?
          dataList.map((row) => (
            <li>
              <img className="white" src={row.profileImage === null ? `${process.env.REACT_APP_PIC_BASE_URL}no_Image.svg` : `${process.env.REACT_APP_PIC_BASE_URL}${row.profileImage}`} alt="" />
              <div className='card_details'>
                <h3 className='m-0'><span className='name'>{row.name}</span> • <span className='age'>{row.age}</span></h3>
                <p className='city m-0 p-0'>{row.userAddress}</p>
                <p className='head mb-1 mt-2'>My Roots:</p>
                <p className='city m-0 p-0'>{row.myRoots}</p>
                <div className='flex mt-2'>
                  <div className='left'>
                    <p className='head mb-1 mt-1'>Culture Group:</p>
                    <p className='city m-0 p-0'>{row.cultureGroup}</p>
                  </div>
                  <div className='rgt'>
                    <p className='head mb-1 mt-1'>Ethnic Group:</p>
                    <p className='city m-0 p-0'>{row.ethnicGroup}</p>
                  </div>
                </div>
                <div className='flex mt-1'>
                  <div className='left'>
                    <p className='head mb-1 mt-1'>Match Date:</p>
                    <p className='city m-0 p-0'>{row.matchDate}</p>
                  </div>
                  {row.blockDate && (
                    <div className='rgt'>
                      <p className='head mb-1 mt-1'>Block Date:</p>
                      <p className='city m-0 p-0'>{row.blockDate}</p>
                    </div>
                  )}
                </div>
              </div>
            </li>
          ))
          : (<li>No data found.</li>)
        }
        </ul>
      </Modal.Body>
    </Modal>
  );
};

export default LikedOrBlockedUsersPopup;
